import sure from '@lskjs/modal/hoc/sure';

export default sure;
